import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import PATHNAME_FILE from "utils/pathname.json";

const useRouteChangeTracker = () => {
    const location = useLocation();

    useEffect(() => {
        document.title = PATHNAME_FILE.pathname_list[location.pathname] || "웅진씽크빅";
    }, [location]);
};

export default useRouteChangeTracker;
